
import { Component, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class ComingSoonCard extends Mixins(VuetifyMixin){
}
